import { render } from "./g-entity-component.vue?vue&type=template&id=ebf4829a&ts=true"
import script from "./g-entity-component.vue?vue&type=script&lang=tsx"
export * from "./g-entity-component.vue?vue&type=script&lang=tsx"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__